import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Progress, Stack } from '@coveord/plasma-mantine';
import { Children, useEffect, useMemo, useState } from 'react';
import { Modal } from '../modal/Modal.js';
import { ModalWizardStep } from './ModalWizardStep.js';
export var ModalWizard = function ModalWizard(_0) {
    var _0_cancelButtonLabel = _0.cancelButtonLabel, cancelButtonLabel = _0_cancelButtonLabel === void 0 ? 'Cancel' : _0_cancelButtonLabel, _0_nextButtonLabel = _0.nextButtonLabel, nextButtonLabel = _0_nextButtonLabel === void 0 ? 'Next' : _0_nextButtonLabel, _0_previousButtonLabel = _0.previousButtonLabel, previousButtonLabel = _0_previousButtonLabel === void 0 ? 'Previous' : _0_previousButtonLabel, _0_finishButtonLabel = _0.finishButtonLabel, finishButtonLabel = _0_finishButtonLabel === void 0 ? 'Finish' : _0_finishButtonLabel, opened = _0.opened, onNext = _0.onNext, onPrevious = _0.onPrevious, onClose = _0.onClose, onFinish = _0.onFinish, isDirty = _0.isDirty, handleDirtyState = _0.handleDirtyState, children = _0.children, isStepValidatedOnNext = _0.isStepValidatedOnNext, isLoading = _0.isLoading, renderFinishButton = _0.renderFinishButton, renderCustomButton = _0.renderCustomButton, mih = _0.mih, modalProps = _object_without_properties(_0, [
        "cancelButtonLabel",
        "nextButtonLabel",
        "previousButtonLabel",
        "finishButtonLabel",
        "opened",
        "onNext",
        "onPrevious",
        "onClose",
        "onFinish",
        "isDirty",
        "handleDirtyState",
        "children",
        "isStepValidatedOnNext",
        "isLoading",
        "renderFinishButton",
        "renderCustomButton",
        "mih"
    ]);
    var _ref, _currentStep_props_showProgressBar;
    var _currentStep_props_validateStep, _currentStep_props;
    var _useState = _sliced_to_array(useState(0), 2), currentStepIndex = _useState[0], setCurrentStepIndex = _useState[1];
    var modalSteps = Children.toArray(children).filter(function(child) {
        return child.type === ModalWizardStep;
    });
    var numberOfSteps = modalSteps.length;
    var isFirstStep = currentStepIndex === 0;
    var isLastStep = currentStepIndex === numberOfSteps - 1;
    var currentStep = modalSteps.filter(function(step, index) {
        return index === currentStepIndex;
    })[0];
    var isValidationOnNext = isStepValidatedOnNext || currentStep.props.validateOnNext;
    var isValid = (isValidationOnNext ? {
        isValid: true
    } : (_ref = currentStep === null || currentStep === void 0 ? void 0 : (_currentStep_props = currentStep.props) === null || _currentStep_props === void 0 ? void 0 : (_currentStep_props_validateStep = _currentStep_props.validateStep) === null || _currentStep_props_validateStep === void 0 ? void 0 : _currentStep_props_validateStep.call(_currentStep_props, currentStepIndex, numberOfSteps)) !== null && _ref !== void 0 ? _ref : {
        isValid: true
    }).isValid;
    useEffect(function() {
        if (opened) {
            setCurrentStepIndex(0);
        }
    }, [
        opened
    ]);
    var handleClose = function handleClose(confirmDirty) {
        if (confirmDirty) {
            var _ref;
            var isModalDirty = (_ref = isDirty === null || isDirty === void 0 ? void 0 : isDirty()) !== null && _ref !== void 0 ? _ref : false;
            if (isModalDirty) {
                var _ref1;
                var discardChanges = (_ref1 = handleDirtyState === null || handleDirtyState === void 0 ? void 0 : handleDirtyState()) !== null && _ref1 !== void 0 ? _ref1 : true;
                if (!discardChanges) {
                    return;
                }
            }
        }
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var resolveStepDependentProp = function resolveStepDependentProp(prop) {
        var value = currentStep.props[prop];
        return typeof value === 'function' ? value(currentStepIndex + 1, numberOfSteps) : value;
    };
    var getProgress = useMemo(function() {
        return function(currStepIndex) {
            var totalNumberOfSteps = modalSteps.filter(function(step) {
                var _step_props_countsAsProgress;
                return (_step_props_countsAsProgress = step.props.countsAsProgress) !== null && _step_props_countsAsProgress !== void 0 ? _step_props_countsAsProgress : true;
            }).length;
            var numberOfCompletedSteps = modalSteps.filter(function(step, index) {
                var _step_props_countsAsProgress;
                return ((_step_props_countsAsProgress = step.props.countsAsProgress) !== null && _step_props_countsAsProgress !== void 0 ? _step_props_countsAsProgress : true) && index <= currStepIndex;
            }).length;
            return numberOfCompletedSteps / totalNumberOfSteps * 100;
        };
    }, [
        isLoading
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({
        opened: opened,
        centered: true,
        onClose: function onClose() {
            return handleClose(true);
        },
        title: resolveStepDependentProp('title'),
        description: resolveStepDependentProp('description'),
        help: resolveStepDependentProp('docLink') ? {
            href: resolveStepDependentProp('docLink'),
            label: resolveStepDependentProp('docLinkTooltipLabel')
        } : undefined
    }, modalProps), {
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                gap: "lg",
                mih: mih,
                children: [
                    ((_currentStep_props_showProgressBar = currentStep.props.showProgressBar) !== null && _currentStep_props_showProgressBar !== void 0 ? _currentStep_props_showProgressBar : true) && /*#__PURE__*/ _jsx(Progress, {
                        w: "100%",
                        color: "navy.5",
                        size: "sm",
                        radius: 0,
                        value: getProgress(currentStepIndex)
                    }),
                    currentStep
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button.Tertiary, {
                        name: isFirstStep ? cancelButtonLabel : previousButtonLabel,
                        onClick: function onClick() {
                            if (isFirstStep) {
                                handleClose(true);
                            } else {
                                onPrevious === null || onPrevious === void 0 ? void 0 : onPrevious(currentStepIndex - 1);
                                setCurrentStepIndex(currentStepIndex - 1);
                            }
                        },
                        children: isFirstStep ? cancelButtonLabel : previousButtonLabel
                    }),
                    !!renderCustomButton && renderCustomButton(isFirstStep),
                    !!renderFinishButton && isLastStep ? renderFinishButton === null || renderFinishButton === void 0 ? void 0 : renderFinishButton(isValid) : /*#__PURE__*/ _jsx(Button.Primary, {
                        disabledTooltip: currentStep.props.disabledTooltipLabel,
                        disabled: !isValid,
                        onClick: function onClick() {
                            if (isLastStep) {
                                var _ref;
                                (_ref = onFinish === null || onFinish === void 0 ? void 0 : onFinish()) !== null && _ref !== void 0 ? _ref : handleClose(false);
                            } else {
                                onNext === null || onNext === void 0 ? void 0 : onNext(currentStepIndex + 1, setCurrentStepIndex);
                                if (!isValidationOnNext) {
                                    setCurrentStepIndex(currentStepIndex + 1);
                                }
                            }
                        },
                        children: isLastStep ? finishButtonLabel : nextButtonLabel
                    })
                ]
            })
        ]
    }));
};
ModalWizard.Step = ModalWizardStep;

//# sourceMappingURL=ModalWizard.js.map